const PREFIX = process.env.REACT_APP_BACKEND_URL + '/annotator';

// API Handler for annotator module of backend server providing annototar
// related methods
export const ANNOTATOR_API = {
  getAllDevices: async (userToken, pageNo, perPage, pagination = 1) => {
    const response = await fetch(
      `${
        process.env.REACT_APP_BACKEND_URL
      }/device/getDevices?page=${pageNo}&per_page=${perPage}&pagination=${Number(
        pagination
      )}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${userToken}`,
        },
      }
    );
    const data = await response.json();
    return data;
  },
  getAllUsers: async (userToken, pageNo, perPage, pagination = 1) => {
    const response = await fetch(
      `${
        process.env.REACT_APP_BACKEND_URL
      }/user/getUsers?page=${pageNo}&per_page=${perPage}&pagination=${Number(
        pagination
      )}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${userToken}`,
        },
      }
    );
    const data = await response.json();
    return data;
  },
  getUserByID: async (userToken, uid) => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/user/getUser/${uid}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${userToken}`,
        },
      }
    );
    const data = await response.json();
    return data;
  },
  getAllEvents: async (
    userToken,
    filterObj,
    pageNo,
    perPage,
    pagination = 1
  ) => {
    const response = await fetch(
      `${
        process.env.REACT_APP_BACKEND_URL
      }/annotator/getAllEvents?page=${pageNo}&per_page=${perPage}&pagination=${Number(
        pagination
      )}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${userToken}`,
        },
        body: JSON.stringify(filterObj),
      }
    );
    const data = await response.json();
    return data;
  },
  getEventsBetweenDateRange: async (
    userToken,
    startDate,
    endDate,
    pageNo,
    perPage,
    pagination = 1
  ) => {
    const response = await fetch(
      `${
        process.env.REACT_APP_BACKEND_URL
      }/annotator/getEventsBetweenDateRange?page=${pageNo}&per_page=${perPage}&pagination=${Number(
        pagination
      )}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${userToken}`,
        },
        body: JSON.stringify({ startDate, endDate }),
      }
    );
    const data = await response.json();
    return data;
  },
  getAnnotationsOfEvent: async (userToken, eventID) => {
    const response = await fetch(`${PREFIX}/getAnnotationsOfEvent/${eventID}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${userToken}`,
      },
    });
    const data = await response.json();
    return data;
  },
  annotate_event: async (userToken, annotations, eventId, comments = '') => {
    const response = await fetch(`${PREFIX}/annotate_event`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${userToken}`,
      },
      body: JSON.stringify({
        annotations,
        lastModifiedIP: '', // to change
        eventId,
        comments,
      }),
    });
    const data = await response.json();
    return data;
  },
  getAllEventClasses: async (userToken) => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/annotator/getAllClassess`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${userToken}`,
        },
      }
    );
    const data = await response.json();
    return data;
  },
  deleteEvent: async (userToken, eventIDs) => {
    const response = await fetch(`${PREFIX}/deleteEvent`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${userToken}`,
      },
      body: JSON.stringify({ eventIdList: eventIDs }),
    });
    const data = await response.json();
    return data;
  },
};
